import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from '../services/i18n';
import { createContext } from 'react';

const LanguageContext = createContext();
const LanguageProvider = ({ children }) => {
	const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

	useEffect(() => {
		// Function to handle language changes
		const handleLanguageChange = (lng) => {
			setCurrentLanguage(lng);
		};

		// Subscribe to language changes
		i18n.on('languageChanged', handleLanguageChange);

		// Cleanup
		return () => {
			i18n.off('languageChanged', handleLanguageChange);
		};
	}, []);

	return <LanguageContext.Provider value={{ currentLanguage }}>{children}</LanguageContext.Provider>;
};

LanguageProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export { LanguageContext, LanguageProvider };
